import { string, bool } from 'prop-types'
import { createComponent } from '@ycos/fela'
import { getFontStyles } from '../'

export const linkStyles = ({ theme, inverseColor, disabled }) => {
  const { type, name, ...link } = theme.custom.link
  const defaultStyles = inverseColor ? link.inverseDefault : link.default
  const hoverStyles = inverseColor ? link.inverseHover : link.hover
  const styles = getFontStyles(theme.typography, { type, name })

  return {
    ...styles,
    ...defaultStyles,
    direction: 'ltr',
    fontSize: link.fontSize || styles.fontSize,
    ':hover': hoverStyles,
    pointerEvents: disabled ? 'none' : undefined
  }
}

const Link = createComponent('a', linkStyles, 'a', ['rel', 'data-seo-segment'])

Link.defaultProps = {
  rel: '',
  target: '_self',
  disabled: false
}

Link.propTypes = {
  rel: string,
  target: string,
  disabled: bool
}

export const LabelLink = createComponent(
  'LabelLink',
  ({ theme, disabled, small }) => {
    const { type, name, ...styles } = small ? theme.custom.labelLink : theme.custom.label
    const defaultStyles = styles.default
    const extraStyles = disabled
      ? styles.disabled
      : {
        ':hover': styles.hover
      }

    const allStyles = {
      ...getFontStyles(theme.typography, { type, name }),
      ...defaultStyles,
      ...extraStyles
    }
    return allStyles
  },
  'a'
)

LabelLink.defaultProps = {
  rel: '',
  target: '_self'
}

LabelLink.propTypes = {
  rel: string,
  target: string
}

export default Link
